module.exports = __webpack_public_path__ + "img/rasmus-henriskon.17855272.png";